import api from "./axiosInstance";

// GET /dashboard/topUsers?start=&end=&limit=
export async function getTopUsers(params) {
	const { start, end, limit = 25 } = params || {};
	const { data } = await api.get("/dashboard/topUsers", {
		params: { start, end, limit }
	});
	return data;
}


